import React, { useEffect, useState } from 'react'
import Layout from '../Layout';
import { Container, Box, Grid, Button, withStyles, CircularProgress } from '@material-ui/core';
import Select from 'react-select';
import SearchIcon from '@material-ui/icons/Search';
import StackedColumnChart from '../Graphs/StackedColumn';
import DataTable from '../Table';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import Accordion from '@material-ui/core/Accordion';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import CustomBreadcrumbs from '../Breadcrumb';
import { useDispatch } from 'react-redux';
import { getPV_planbySupplierId, getPV_Reports } from '../../ReduxStore/CreatePlanSlice';
import { getVendorData } from '../../ReduxStore/VendorDataSlice';
import { GridLoadingSpinner } from '@tmlconnected/avant-garde-components-library';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

// Create a styled version of the Button component
const CustomButton = withStyles({
    root: {
        fontSize: '14px',
        textTransform: 'Capitalize',
    },
})(Button);



// const columns = [
//     { id: 'nextDueDate', label: 'Next Due Date', minWidth: 100 },
//     { id: 'lastDoneDate', label: 'Last Done Date', minWidth: 100 },
//     { id: 'totalAssets', label: 'Total Assets', minWidth: 100 },
//     { id: 'doneAssets', label: 'Done Assets', minWidth: 100 },
//     { id: 'photoUploadedAssets', label: 'Photo Uploaded Assets', minWidth: 150 },
//     { id: 'missingAssetsBySuppliers', label: 'Missing Assets by Suppliers', minWidth: 180 },
// ];

const columns = [
    { id: 'plan_id', label: 'Plan ID', minWidth: 100 },
    { id: 'frequency', label: 'Frequency', minWidth: 100 },
    { id: 'supplier_id', label: 'Supplier ID', minWidth: 100 },
    { id: 'first_plan_date', label: 'First Plan Date', minWidth: 150 },
    { id: 'current_plan_date', label: 'Current Plan Date', minWidth: 150 },
    { id: 'attended_date', label: 'Attended Date', minWidth: 150 },
    { id: 'approval_time', label: 'Approval Time', minWidth: 150 },
    { id: 'total_checkpoints', label: 'Total Checkpoints', minWidth: 120 },
    { id: 'duration', label: 'Duration', minWidth: 100 },
    { id: 'status', label: 'Status', minWidth: 100 },
    { id: 'reschedule', label: 'Reschedule', minWidth: 100 },
    { id: 'NG_resolved', label: 'NG Resolved', minWidth: 100 },
    { id: 'NG_submitted', label: 'NG Submitted', minWidth: 120 },
    { id: 'NG_checkpoints', label: 'NG Checkpoints', minWidth: 120 },
    { id: 'checkpoints_submitted', label: 'Checkpoints Submitted', minWidth: 180 },
    { id: 'Ok_checkpoints', label: 'OK Checkpoints', minWidth: 120 },
];


const rows = [
    {
        nextDueDate: '2024-06-30',
        lastDoneDate: '2024-06-10',
        totalAssets: 100,
        doneAssets: 80,
        photoUploadedAssets: 70,
        missingAssetsBySuppliers: 5
    },
    {
        nextDueDate: '2024-07-15',
        lastDoneDate: '2024-06-15',
        totalAssets: 150,
        doneAssets: 130,
        photoUploadedAssets: 110,
        missingAssetsBySuppliers: 10
    },
    {
        nextDueDate: '2024-07-20',
        lastDoneDate: '2024-06-20',
        totalAssets: 200,
        doneAssets: 190,
        photoUploadedAssets: 180,
        missingAssetsBySuppliers: 15
    },
];

const PVReports = () => {
    const breadcrumbsLinks = [
        { label: 'Home', href: '/' },
        { label: 'Physical Verification', href: '/physical-verification' },
    ];
    const dispatch = useDispatch();
    const Role = localStorage.getItem("userRole");
    // const Vendor_code = localStorage.getItem("vendorCode");
    const [vendor_code, setVendor_code] = useState('');
    const [SupplierOptions, setSupplierOptions] = useState(null);
    const [selectedSupplier, setselectedSupplier] = useState(null);
    const [allVendor, setAllVendor] = useState(false);
    const [show, setShow] = useState(false);
    const [loading, setLoading] = useState(false);
    const [searchLoading, setSearchLoading] = useState(false);
    const [report, setReport] = useState({});
    const [vendors, setVendors] = useState();
    // const [planId, setplanId] = useState();
    // const [record, setRecord] = useState();
    const [selectedYear, setSelectedYear] = useState(null);
    // const [chartData, setChartData] = useState([]);
    // const [formData, setFormData] = useState({
    //     startDate: '',
    //     endDate: '',
    //     frequency: '',
    // });

    // const formatDateTime = (date) => {
    //     return new Date(date).toISOString().slice(0, 19);
    // };

    // const yearOptions = [
    //     { value: '2024-04-01', label: '2024' },
    //     { value: '2025-04-01', label: '2025' }
    // ];

    const makeYearOptions = (startYear = 2024, endYear = new Date().getFullYear()) => {
    const options = [];
    for (let y = startYear; y <= endYear; y++) {
        options.push({
        value: `${y}-04-01`, // same format as you hardcoded
        label: String(y),
        });
    }
    return options;
    };

    // example: from 2024 up to current year
    const yearOptions = makeYearOptions(2024);


    // const handleInputChange = (e) => {
    //     const { name, value } = e.target;
    //     // let formattedValue = value;

    //     // if (name === 'startDate' || name === 'endDate') {
    //     //     formattedValue = formatDateTime(value);
    //     // }

    //     setFormData({
    //         ...formData,
    //         [name]: value,
    //     });
    // };


    useEffect(() => {
        const Supplierlist = vendors && vendors.map(item => ({
            label: `${item.vendor_group} (${item.vendor})`,
            value: item.vendor,
            location: item.location // Add location here
        }));
        console.log("Supplierlist", Supplierlist);

        // if (Supplierlist) {
        //     setSupplierOptions(Supplierlist.map((item, index) => ({
        //         value: item.value,
        //         label: item.label,
        //         location: item.location
        //     })));
        // }

        if (Supplierlist) {
            setSupplierOptions([
                { value: true, label: "All", location: "" }, // Add "All" option at the top
                ...Supplierlist.map(item => ({
                    value: item.value,
                    label: item.label,
                    location: item.location
                }))
            ]);
        }

    }, [vendors]);

    // const handleSupplierChange = async (event) => {
    //     const supplier_id = event.target.value;
    //     setselectedSupplier(event.target.value);
    //     const action = dispatch(getPV_planbySupplierId(supplier_id));
    //     const res = await action.unwrap();
    //     console.log("hhhhhhhhhhh", res.result.PV_plan[0].id);
    //     setplanId(res.result.PV_plan[0].id);
    // };


    // const formatChartData = (data) => {
    //     return {
    //         title: "Asset Overview",
    //         categories: ["Assets"],  // Only one category since each property will be a bar
    //         yAxis: "Number of Assets",
    //         series: [
    //             { name: "Total Assets for Vendor", data: [data.asset_count_for_vendor] },
    //             { name: "Total Assets Done", data: [data.total_assets_done] },
    //             { name: "Total OK Checkpoints", data: [data.total_ok_checkpoints] },
    //             { name: "Total NG Checkpoints", data: [data.total_ng_checkpoints] },
    //             { name: "Total NG Raised", data: [data.total_ng_raised] },
    //             { name: "Total NG Resolved", data: [data.total_ng_resolved] },
    //             { name: "Total NG Rejected", data: [data.total_ng_rejected] },
    //             { name: "Assets with Images", data: [data.assets_with_images] },
    //             { name: "Assets with Location", data: [data.assets_with_location] },
    //         ],
    //     };
    // };

    const formatChartData = (data) => {
        return {
            title: "Asset Overview",
            categories: [
                "Total Assets for Vendor",
                "Total Assets Done",
                "Total OK Checkpoints",
                "Total NG Checkpoints",
                "Total NG Raised",
                "Total NG Resolved",
                "Total NG Rejected",
                "Assets with Images",
                "Assets with Location"
            ],
            yAxis: "Number of Assets",
            series: [
                {
                    name: "Assets",
                    data: [
                        data.asset_count_for_vendor,
                        data.total_assets_done,
                        data.total_ok_checkpoints,
                        data.total_ng_checkpoints,
                        data.total_ng_raised,
                        data.total_ng_resolved,
                        data.total_ng_rejected,
                        data.assets_with_images,
                        data.assets_with_location
                    ]
                }
            ]
        };
    };


    const getReports = async () => {
        if (!selectedYear) {
            toast.error("Please select the Year!")
            return
        }
        setSearchLoading(true)
        try {
            const action = dispatch(getPV_Reports(`?vendor_code=${vendor_code}&from_date=${selectedYear.value}&all=${allVendor}`));
            const res = await action.unwrap();
            console.log("check Report==,", res)
            if (res.result) {
                setSearchLoading(false)
                // Transform data for chart
                const chartData = formatChartData(res.result);
                setReport(chartData);
                setShow(true)
            }
        } catch (error) {
            // toast.error(error.message || "No Data Found!");
            toast.error("No Data Found!")
        } finally {
            setSearchLoading(false)
        }

    }
    // const handler = async () => {
    //     // from_time=2023-03-09T01:00:00&to_time=2024-08-15T01:00:00
    //     console.log("data:", formData.startDate, formData.frequency, formData.endDate)
    //     const action = dispatch(getPV_Reports({ plan_id: planId, freq: formData.frequency, fromTime: formatDateTime(formData.startDate), toTime: formatDateTime(formData.endDate) }));
    //     const res = await action.unwrap();
    //     const transformedReports = Object.keys(res.result.reports).flatMap(key => res.result.reports[key]);
    //     console.log("resposnse of report:", transformedReports)
    //     setReport(transformedReports);
    //     const recordsArray = Object.keys(res.result.records).map(key => ({
    //         id: key,
    //         ...res.result.records[key]
    //     }));
    //     setRecord(recordsArray);
    //     console.log(recordsArray);
    //     setShow(true)
    // }

    // const chartData = [
    //     {
    //         title: "Physical Verification",
    //         categories: ["Done", "Pending"],
    //         series: [
    //             {
    //                 name: 'Pending',
    //                 color: "#8B8000",
    //                 data: [0, 8]
    //             },
    //             {
    //                 name: 'Done',
    //                 color: '#027148',
    //                 data: [5, 0]
    //             }
    //         ],
    //         // yAxis: "PM"
    //     },



    // ]

    const getVendors = async () => {
        const action = dispatch(getVendorData());
        const res = await action.unwrap();
        console.log("vednor data:", res)
        setVendors(res.result)
    }

    useEffect(() => {
        const fetchData = async () => {
            setLoading(true)
            await getVendors();
            setLoading(false);
        };
        if (Role === "admin" || Role === "view_only") {
            fetchData();
        }

    }, [Role])

    useEffect(() => {
        if (Role === "admin" || Role === "view_only") {
            if (selectedSupplier) {
                if (selectedSupplier.label === "All") {
                    console.log("IF ALL RUN", selectedSupplier)
                    setAllVendor(selectedSupplier.value)
                } else {
                    console.log("else RUN VendorCode")
                    setVendor_code(selectedSupplier.value);
                }

            }

        } else {
            const Vendor_code = localStorage.getItem("vendorCode");
            setVendor_code(Vendor_code);
        }
    }, [Role, selectedSupplier])

    if (loading) {
        return (
            <Layout>
                <Container>
                    <Box mt={4} display="flex" justifyContent="center" alignItems="center" minHeight="80vh" >
                        <GridLoadingSpinner />
                    </Box>
                </Container>
            </Layout>
        );
    }

    return (
        <Layout>
            <Container>
                <Box mt={1} mb={2}>
                    <CustomBreadcrumbs links={breadcrumbsLinks} current="Reports" />
                </Box>
                <Box mb={2}>
                    <Grid container spacing={2}>
                        {/* <Grid item xs={6} sm={2}>
                            <FormControl fullWidth variant="outlined">
                                <InputLabel id="supplier-label">Supplier Name</InputLabel>
                                <Select
                                    labelId="supplier-label"
                                    value={selectedSupplier}
                                    onChange={handleSupplierChange}
                                    label="Supplier Name"
                                >
                                    {vendors && vendors.map((item, index) => (
                                        <MenuItem value={item.id} key={index}>{item.vendor_group}</MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        </Grid> */}
                        {(Role === "admin" || Role === "view_only") && <Grid item xs={12} sm={2}>
                            <Select
                                // styles={customStyles}
                                options={SupplierOptions}
                                placeholder="Select Vendor"
                                isSearchable
                                onChange={setselectedSupplier}
                                isClearable
                                menuPlacement="auto"
                            />
                        </Grid>}
                        <Grid item xs={7} sm={2}>
                            <Select
                                // styles={customStyles}
                                options={yearOptions}
                                placeholder="Select Year"
                                isSearchable
                                onChange={setSelectedYear}
                                isClearable
                                menuPlacement="auto"
                            />
                        </Grid>
                        {/* <Grid item xs={2}>
                            <TextField
                                label="From"
                                name="startDate"
                                type="date"
                                variant="outlined"
                                fullWidth
                                InputLabelProps={{
                                    shrink: true,
                                }}
                                value={formData.startDate}
                                onChange={handleInputChange}
                            />
                        </Grid> */}
                        {/* <Grid item xs={2}>
                            <TextField
                                label="To"
                                name="endDate"
                                type="date"
                                variant="outlined"
                                fullWidth
                                InputLabelProps={{
                                    shrink: true,
                                }}
                                value={formData.endDate}
                                onChange={handleInputChange}
                            />
                        </Grid> */}
                        {/* <Grid item xs={2}>
                            <FormControl variant="outlined" fullWidth>
                                <InputLabel>Time Frame</InputLabel>
                                <Select
                                    label="Frequency"
                                    name="frequency"
                                    value={formData.frequency}
                                    onChange={handleInputChange}
                                >
                                    <MenuItem value="week">Weekly</MenuItem>
                                    <MenuItem value="month">Monthly</MenuItem>
                                    <MenuItem value="quarter">Quarterly</MenuItem>
                                    <MenuItem value="year">Yearly</MenuItem>
                                </Select>
                            </FormControl>
                        </Grid> */}
                        <Grid item xs={5} sm={2}>
                            <CustomButton
                                type="submit"
                                variant="contained"
                                color="primary"
                                className="customButton"
                                // startIcon={<SearchIcon />}
                                // onClick={handler}
                                onClick={getReports}
                                endIcon={searchLoading ? <CircularProgress size={20} /> : <SearchIcon />}
                                disabled={searchLoading} // Optionally disable the button when loading
                            >
                                {searchLoading ? "Searching" : "Search"}
                            </CustomButton>
                        </Grid>
                    </Grid>
                </Box>
                {show && <Box>
                    <Grid container spacing={2}>
                        <Grid item xs={12} sm={8}>
                            <StackedColumnChart data={report} />
                        </Grid>
                        <Grid item xs={6}>
                            {/* <StackedColumnChart data={chartData[1]} /> */}
                        </Grid>
                        {/* <Grid container spacing={2}>
                            <Grid item xs={12}>
                                <Accordion>
                                    <AccordionSummary
                                        expandIcon={<ExpandMoreIcon />}
                                        aria-controls="panel1a-content"
                                        id="panel1a-header"
                                    >
                                        <Typography>View Table</Typography>
                                    </AccordionSummary>
                                    <AccordionDetails>
                                        <DataTable data={record} columns={columns} />
                                    </AccordionDetails>
                                </Accordion>

                            </Grid>
                        </Grid> */}
                    </Grid>
                </Box>}
            </Container>
            <ToastContainer />
        </Layout>
    )
}

export default PVReports